import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SeoHeadProps {
    title?: string;
    description?: string;
    canonicalUrl?: string;
    type?: string;
    name?: string;
}

export const SeoHead: React.FC<SeoHeadProps> = ({
    title = 'Spirit Research Lab | מעבדה לחקר הרוח',
    description = 'Spirit Research Lab - מעבדה לחקר הרוח. כאן תוכלו לחשב, לשמור ולהשוות נתונים אסטרולוגיים, נומרולוגיים וקבליים בשיטת שבתאי. אספו מפות של אנשים קרובים, השוו ביניהן וגלו בעצמכם את הדפוסים.',
    canonicalUrl,
    type = 'website',
    name = 'Spirit Research Lab'
}) => {
    const siteUrl = 'https://spirit-research-lab.com';
    const location = useLocation();

    // Fallback to current path if no explicit canonical URL is passed
    const activePath = canonicalUrl !== undefined ? canonicalUrl : location.pathname;

    // Normalize canonical URL: No trailing slashes, ensure it starts with /
    const normalizedPath = activePath === '/' ? '' : activePath.replace(/\/$/, '');

    const fullCanonicalUrl = normalizedPath.startsWith('http')
        ? normalizedPath
        : `${siteUrl}${normalizedPath.startsWith('/') ? '' : '/'}${normalizedPath}`;

    return (
        <Helmet>
            {/* Basic Metadata */}
            <title>{title}</title>
            <meta name="description" content={description} />
            {fullCanonicalUrl && <link rel="canonical" href={fullCanonicalUrl} />}

            {/* Open Graph / Facebook */}
            <meta property="fb:app_id" content="827670076739526" />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={name} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {fullCanonicalUrl && <meta property="og:url" content={fullCanonicalUrl} />}
            <meta property="og:image" content={`${siteUrl}/og-image.png`} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={`${siteUrl}/og-image.png`} />
        </Helmet>
    );
};
